import { render, staticRenderFns } from "./WizardRuleTabs.vue?vue&type=template&id=217516d0"
import script from "./WizardRuleTabs.vue?vue&type=script&lang=js"
export * from "./WizardRuleTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports